// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__g0ceS","sendOtp":"AuthorizeToLogin_sendOtp__3t1ep"};